// DATE Constants
export const LOCALES_DEFAULT = "default";

export const NUMERIC_FORMAT = "numeric";

export const TWO_DIGIT_FORMAT = "2-digit";

export const UTC = "UTC";

export const CUSTOM_ATTRIBUTE_BULK_PREFIX = "customattributes.";
export const CAMPAIGN_PLANNED_START_DATE = "campaignstartdateplanned";
export const CAMPAIGN_PLANNED_END_DATE = "campaignenddateplanned";
export const FLIGHTPLANS_START_DATE = "startDate";
export const FLIGHTPLANS_END_DATE = "endDate";
export const CAMPAIGN_NAME = "campaignname";
export const FLIGHTPLANS_NAME = "name";

export const DATE_FORMAT = "YYYY-MM-DD";

// Resource Names
export const RESOURCE_CAMPAIGN = "Campaign";
export const RESOURCE_FLIGHT_PLANS = "Flight plans";
export const RESOURCE_BULK = "Bulk jobs";

// Resource Plural Names
export const RESOURCE_CAMPAIGN_PLURAL = "Campaigns";

export const SELECTED_BU = "selectedBU";

// Spends
export const VARIABLE_SPEND_SUFFIX = "variable";
export const FIXED_SPEND_SUFFIX = "fixed";
export const UNALLOCATED_SPEND_SUFFIX = "unallocated";

// Scroll
export const SCROLL_BEHAVIOR = "smooth";
export const SCROLL_BLOCK = "start";

// Refs name
export const REF_BUSINESS_UNIT = "businessUnitRef";
export const REF_BASIC_DETAILS = "basicDetailsRef";
export const REF_CUSTOM_ATTRIBUTES = "customAttributesRef";
export const REF_SPEND = "spendRef";

//API Calls
export const API_CALL_NAME = {
  CAMPAIGNS: "campaigns",
  BULK_JOBS: "bulkjobs",
  FLIGHT_PLANS: "flightplans",
  MEDIA_ITEMS: "mediaitems",
  USERS: "users",
};

//Table Selection Types
export const TABLE_SELECTION_TYPE_SINGLE = "single";
export const TABLE_SELECTION_TYPE_MULTI = "multi";
// Access Levels
export const ACCESS_LEVEL = {
  READ_ONLY: "r",
  READ_WRITE: "rw",
  UNKNOWN: "unk",
};

/**
 * Entity types
 * Refer to Smithy model
 * https://code.amazon.com/packages/MODETaCSMetadataServiceModel/blobs/399597da3109b3db8af415a076e16f6b52ba6680/--/model/resources/common/datatypes.smithy#L219-L227
 */
export const ENTITY_TYPE = {
  CAMPAIGNS: "campaign",
  FLIGHT_PLANS: "flight-plan",
  MEDIA_ITEMS: "media-item",
  MEDIA_ID_REQUEST: "media-id-request",
  USERS: "user",
};

export const BULK_JOB_STATUS = {
  FAILED: "Failed",
  SYSTEM_ERROR: "System Error",
  SUCCEEDED: "Succeeded",
};

//Table Preferences
export const PAGE_SIZE = 10;

export const REQUEST_ID_SELECTOR = {
  WITH_TACS_ID: "with-tacs-id",
  WITHOUT_TACS_ID: "without-tacs-id"
};
